// Audit Trail: the routes and the sidebar rows of `wealth.compliance.audit-trail` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.compliance.audit-trail',
    routes: [
        {
            frontend: 'comply',
            path: 'audit-trail',
            lazy: () => import('@/pages/comply/audit-trail/page'),
        },
    ],
    nav: [
        {
            frontend: 'comply',
            key: 'audit-trail',
            label: 'Audit Trail',
            href: '/comply/audit-trail',
            icon: 'ScrollText',
            group: 'monitoring',
            order: 450,
        },
    ],
});
